export default (theme) => ({
    container: { padding: theme.spacing(2) },
    menuItem: {
        textTransform: "capitalize",
    },
});
